'use client';

import React from 'react';
import { CidAtmosphere } from '@/components/common/CidAtmosphere';
import { Footer } from '@/components/common/Footer';
import { Header } from '@/components/common/Header';
import { SkipLink } from '@/components/common/SkipLink';
import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/lib/constants';

const NotFound = () => {
  const handleGoBack = () => {
    if (typeof window !== 'undefined') {
      window.history?.back();
    }
  };

  return (
    <div className="cid-site" style={{ display: 'flex', flexDirection: 'column' }}>
      <SkipLink target="main-content" />
      <CidAtmosphere mode="viewport" />
      <Header />
      <div
        className="cid-container"
        style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '48px var(--cid-gutter, 32px)' }}
      >
        <main id="main-content" style={{ width: '100%' }}>
          <section
            className="cid-panel"
            style={{ maxWidth: '680px', margin: '0 auto', padding: '40px 32px', borderRadius: '20px' }}
          >
            <p className="cid-eyebrow">404 / PAGE NOT FOUND</p>
            <h1 style={{ margin: '0 0 14px', fontSize: 'clamp(32px, 4vw, 46px)', lineHeight: 1.15 }}>
              Page not found.
            </h1>
            <p className="cid-intro">
              The page you&apos;re looking for doesn&apos;t exist or has moved. Return to the
              homepage or open the live Commodities Terminal.
            </p>
            <div className="cid-hero-actions">
              <Button href={ROUTES.home}>Back to Home</Button>
              <Button href={ROUTES.terminal} variant="secondary">
                Open Terminal
              </Button>
              <Button onClick={handleGoBack} variant="secondary">
                Go Back
              </Button>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
